/* LatestPromptRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */
/** @jsxFrag */
import "./LatestPromptRenderer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { ReactRenderer } from '@atlaskit/renderer';
import { RendererActionsContext } from '@atlaskit/renderer/actions';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var rendererContainerStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var rendererDocumentStyles = null;
var RendererWrapper = function RendererWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1reo15vq _18m915vq _l0ms15vq _1aiy15vq _btic1l2s _pkxt1q9c _1wzj1wug _usad1hna _ceky13dz _hgabu2gc _1vmmkb7n _hgakkb7n _p8i3j915 _1a6vb3bt _1mrdf705 _q3ck1q9c", "_c71loqi3 _motn1m6u _1u151tcg"]),
    style: {
      "--_nj3yu9": ix("calc(".concat("var(--ds-space-250, 20px)", " + ", "var(--ds-space-050, 4px)", ")")),
      "--_wef7xl": ix("calc(24px + ".concat("var(--ds-space-050, 4px)", ")"))
    }
  }, children);
};
export var LatestPromptRenderer = function LatestPromptRenderer(_ref2) {
  var promptADF = _ref2.promptADF,
    providerFactory = _ref2.providerFactory;
  var jsonDocument = promptADF;
  return /*#__PURE__*/React.createElement(RendererActionsContext, null, /*#__PURE__*/React.createElement(RendererWrapper, null, /*#__PURE__*/React.createElement(ReactRenderer, {
    document: jsonDocument,
    media: {
      // We don't currently support images with captions
      allowLinking: false
    }
    // By default -- the renderer uses a "default schema" which supports all
    // the nodes and marks the markdown transformer can create.
    // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
    ,
    useSpecBasedValidator: true,
    dataProviders: providerFactory,
    maxHeight: 20
  })));
};